import type { MetaDashboardApi, MetaData, MetaDataApi } from '../../type';

export const META_DASHBOARD_KEYS = {
  getCollected: (param?: MetaDashboardApi.GetCollected.Request) =>
    param
      ? (['metaDashboardApi.getCollected', param] as const)
      : (['metaDashboardApi.getCollected'] as const),
  getRegion: (param?: MetaDashboardApi.GetRegion.Request) =>
    param
      ? (['metaDashboardApi.getRegion', param] as const)
      : (['metaDashboardApi.getRegion'] as const),
  getRegionCodeList: (param?: MetaDashboardApi.GetRegionCodeList.Request) =>
    param
      ? (['metaDashboardApi.getRegionCodeList', param] as const)
      : (['metaDashboardApi.getRegionCodeList'] as const),
  getSummary: (param?: MetaDashboardApi.GetSummary.Request) =>
    param
      ? (['metaDashboardApi.getSummary', param] as const)
      : (['metaDashboardApi.getSummary'] as const),
  getMetaList: (param?: MetaDashboardApi.GetMetaListByRegionCode.Request) =>
    param
      ? (['metaDashboardApi.getMetaList', param] as const)
      : (['metaDashboardApi.getMetaList'] as const),
  getCoverageRouteSegmentList: (pathList?: string[]) =>
    pathList
      ? (['metaDashboardApi.getCoverageRouteSegmentList', pathList] as const)
      : (['metaDashboardApi.getCoverageRouteSegmentList'] as const),
};

export const META_DATA_KEYS = {
  getCount: (filter?: Partial<MetaDataApi.GetCount.Request>) =>
    filter
      ? (['metaDataApi.getCount', filter] as const)
      : (['metaDataApi.getCount'] as const),
  getDetail: (id?: MetaData['id']) =>
    id != null
      ? (['metaDataApi.getDetail', id] as const)
      : (['metaDataApi.getDetail'] as const),
  getLinkedProjectList: (metaDataId?: MetaData['id']) =>
    metaDataId != null
      ? (['metaDataApi.getLinkedProjectList', metaDataId] as const)
      : (['metaDataApi.getLinkedProjectList'] as const),
  getList: (filter?: Partial<MetaDataApi.GetList.Request>) =>
    filter
      ? (['metaDataApi.getList', filter] as const)
      : (['metaDataApi.getList'] as const),
  getLidarList: () => ['metaDataApi.getLidarList'] as const,
  getStorage: (filter?: MetaDataApi.GetStorage.Request) =>
    filter
      ? (['metaDataApi.getStorage', filter] as const)
      : (['metaDataApi.getStorage'] as const),
};
